import { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { MarkdownPreviewer } from 'primary-components';

import { MESSAGE_TYPE } from '../../constants';
import CodeDiff from './CodeDiff';

import classNames from 'classnames';
import './Message.scss';

const Message = ({ generatedCode, message = "", setContent, sourceCode, type }) => {
  const previewerRef = useRef()

  useEffect(() => {
    previewerRef.current?.setContent(message)
  }, [message, type])

  return (
    <div
        className={classNames(
          "ng-python-editor__chat__content__chat__row",
          { "ng-python-editor__chat__content__chat__row--is-user": type === MESSAGE_TYPE.USER },
          { "ng-python-editor__chat__content__chat__row--is-bot": type === MESSAGE_TYPE.BOT }
        )}
    >
      <div className={classNames(
        "ng-python-editor__chat__content__chat__row__message",
        { "ng-python-editor__chat__content__chat__row__message--with-diff": type === MESSAGE_TYPE.BOT && generatedCode },
      )}>
        <MarkdownPreviewer ref={previewerRef}/>
        {type === MESSAGE_TYPE.BOT && generatedCode ? (
          <CodeDiff
              afterCode={generatedCode}
              beforeCode={sourceCode}
              onApply={setContent}
          />
        ) : undefined}
      </div>
    </div>
  )
}

Message.propTypes = {
  generatedCode: PropTypes.string,
  message: PropTypes.string,
  setContent: PropTypes.func,
  sourceCode: PropTypes.string,
  type: PropTypes.oneOf(Object.values(MESSAGE_TYPE)).isRequired
}

export default memo(Message);
